class MarketLanguageSelector extends HTMLElement {
  constructor() {
    super();
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  connectedCallback() {
    this.trigger = this.querySelector('[data-market-trigger]');
    this.panel = this.querySelector('[data-market-panel]');
    this.overlay = this.querySelector('[data-market-overlay]');
    this.closeBtn = this.querySelector('[data-market-close]');
    this.form = this.querySelector('form');
    this.items = Array.from(this.querySelectorAll('[data-market-item]'));
    this.variant = this.dataset.variant;

    if (!this.trigger || !this.panel) return;

    this.trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggle();
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.close();
      });
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', () => {
        this.close();
      });
    }

    if (this.form) {
      this.form.addEventListener('submit', () => {
        this.classList.add('is-submitting');
      });
    }

    if (this.variant === 'drawer') {
      this.updateDrawerFooterHeight();
      window.addEventListener('resize', () => this.updateDrawerFooterHeight());
    }
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleDocumentClick);
    document.removeEventListener('keydown', this.handleKeydown);
  }

  updateDrawerFooterHeight() {
    const drawerFooter = document.querySelector('.header-menu__drawer-footer');
    if (drawerFooter) {
      const height = drawerFooter.getBoundingClientRect().height;
      this.style.setProperty('--drawer-footer-height', `${height}px`);
    }
  }

  isOpen() {
    return this.classList.contains('is-open');
  }

  open() {
    if (this.isOpen()) return;
    this.classList.add('is-open');
    this.trigger.setAttribute('aria-expanded', 'true');
    this.panel.removeAttribute('hidden');

    if (this.variant === 'drawer') this.updateDrawerFooterHeight();

    document.addEventListener('click', this.handleDocumentClick);
    document.addEventListener('keydown', this.handleKeydown);

    const activeItem = this.querySelector('.market-selector__item.is-active') || this.items[0];
    if (activeItem) {
      requestAnimationFrame(() => activeItem.focus());
    }
  }

  close() {
    if (!this.isOpen()) return;
    this.classList.remove('is-open');
    this.trigger.setAttribute('aria-expanded', 'false');

    document.removeEventListener('click', this.handleDocumentClick);
    document.removeEventListener('keydown', this.handleKeydown);

    setTimeout(() => {
      if (!this.isOpen()) this.panel.setAttribute('hidden', '');
    }, 250);
  }

  toggle() {
    this.isOpen() ? this.close() : this.open();
  }

  handleDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.close();
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.close();
      this.trigger.focus();
      return;
    }

    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      if (!this.items.length) return;
      const focused = document.activeElement;
      const idx = this.items.indexOf(focused);
      if (idx === -1) return;
      event.preventDefault();
      const direction = event.key === 'ArrowDown' ? 1 : -1;
      const nextIdx = (idx + direction + this.items.length) % this.items.length;
      this.items[nextIdx].focus();
    }

    if (event.key === 'Home') {
      if (this.items.length) {
        event.preventDefault();
        this.items[0].focus();
      }
    }

    if (event.key === 'End') {
      if (this.items.length) {
        event.preventDefault();
        this.items[this.items.length - 1].focus();
      }
    }
  }
}

if (!customElements.get('market-language-selector')) {
  customElements.define('market-language-selector', MarketLanguageSelector);
}
